import React from 'react';
import PropTypes from 'prop-types';
import { SectionHeader } from './SectionHeader';
import './Panel.css';

/**
 * Flat content panel / card — sharp border, no shadow.
 * Use for interactive containers only (plan: no decorative cards).
 * Optional title/actions compose SectionHeader (no parallel panel-header primitive).
 */
export function Panel({
  children,
  as: Component = 'section',
  padded = true,
  title = null,
  actions = null,
  tone = 'default',
  className = '',
  ...props
}) {
  const hasHeader = Boolean(title || actions);

  return (
    <Component
      className={[
        'onyx-panel',
        padded && !hasHeader ? 'onyx-panel--padded' : '',
        hasHeader ? 'onyx-panel--with-header' : '',
        tone !== 'default' ? `onyx-panel--${tone}` : '',
        className,
      ].filter(Boolean).join(' ')}
      data-testid="onyx-panel"
      data-tone={tone}
      {...props}
    >
      {hasHeader ? (
        <>
          <SectionHeader
            title={title}
            actions={actions}
            as="h3"
            className="onyx-panel__header"
          />
          <div
            className={[
              'onyx-panel__body',
              padded ? 'onyx-panel__body--padded' : '',
            ].filter(Boolean).join(' ')}
          >
            {children}
          </div>
        </>
      ) : (
        children
      )}
    </Component>
  );
}

Panel.propTypes = {
  children: PropTypes.node,
  as: PropTypes.elementType,
  padded: PropTypes.bool,
  title: PropTypes.node,
  actions: PropTypes.node,
  tone: PropTypes.oneOf(['default', 'success', 'warning', 'error', 'info']),
  className: PropTypes.string,
};

/** @deprecated Prefer Panel */
export const Card = Panel;

export default Panel;
